module.exports = __webpack_public_path__ + "img/unmount.791789cd.svg";